import { render, staticRenderFns } from "./TopicAnswerPanel.vue?vue&type=template&id=0e66f7c5&scoped=true"
import script from "./TopicAnswerPanel.vue?vue&type=script&lang=js"
export * from "./TopicAnswerPanel.vue?vue&type=script&lang=js"
import style0 from "./TopicAnswerPanel.vue?vue&type=style&index=0&id=0e66f7c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e66f7c5",
  null
  
)

export default component.exports